import type { TraitQuery } from "src/graphql";

export enum TraitType {
  Active = "active",
  Templates = "templates",
  Archived = "archived",
}

export enum ModelType {
  Parent = "parent",
  Related = "related",
  Event = "event",
  GeneralModel = "general_model",
}

export type Model = {
  id: string;
  name: string;
  is_general_model?: boolean;
  description?: string | null;
  connection: {
    id: string;
    definition: {
      name: string;
      icon: string;
    };
  } | null;
  primary_key: string | null;
  event: {
    timestamp_column: string;
    event_model_event_sources?: readonly unknown[] | null;
  } | null;
  filterable_audience_columns: {
    alias: string | null;
    name: string;
  }[];
};

export type TraitRow = NonNullable<TraitQuery["trait_definitions_by_pk"]>;

type TraitParentModel = NonNullable<TraitRow["parent_model"]>;

// The trait resolvers only return rows whose parent model passes the same
// visibility filter, so the segment remote join can't actually be null even
// though the stitched schema types it as nullable. Data-fetching components
// normalize to this once at the boundary with `toTraitWithParentModel` (per the
// frontend narrowing convention); leaf components take it as their prop type.
export type TraitWithParentModel = TraitRow & {
  parent_model: TraitParentModel;
};
